<template>
    <div class="main-bd mg20 pro-visible">
        <el-row class="searchSection">
            <el-form ref="form" :inline="true" :model="searcheModel" class="external-form">
                <el-form-item label="目标年份">
                    <el-date-picker
                        v-model="searcheModel.year"
                        type="year"
                        format="yyyy"
                        value-format="yyyy"
                        placeholder="选择年">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="所属部门">
                    <UserCascader
                    v-model="searcheModel.branch_id"
                    ref="branch"
                    :isBusiness="true"
                    @change="changeBranch"
                    ></UserCascader>
                </el-form-item>
                <el-form-item label="业务员">
                    <UserSelect ref="user" @change="changeUser"></UserSelect>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                    <ExportFile 
                    :url="'/api/export/' + activeName" 
                    :params="searcheModel" 
                    :filename="searcheModel.active_name == 'branch-goal' ? '新增业绩目标(部门)' : '新增业绩目标(成员)'" 
                    buttonName="导出Excel"
                    buttonType="success">
                    </ExportFile>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row class="searchSection">
            <el-col :span="22">
                <el-tabs type="card" v-model="searcheModel.count_type" @tab-click="handleClick">
                    <el-tab-pane label="按部门" name="1"></el-tab-pane>
                    <el-tab-pane label="按成员" name="2"></el-tab-pane>
                </el-tabs>
            </el-col>
            <el-col :span="2">
                <CountConfig v-if="Acs('/count-config/view')" :path="$route.path" tab="goal-manage-pfm"></CountConfig>
            </el-col>
        </el-row>
        <el-row class="searchSection">
            <el-col :span="6" :offset="18">
                <ImportFile 
                v-if="Acs('/import/' + searcheModel.active_name) && is_edit && !hasOrderSensitiveData(list)"
                :templateFileUrl="'/api/export/' + searcheModel.active_name + '-template'" 
                :url="'/api/import/' + searcheModel.active_name"  
                :params="searcheModel" 
                dialogTitle="部门目标" 
                buttonText="导入目标"
                buttonType="warning"
                @import_success="importSuccess">
                </ImportFile>&nbsp;&nbsp;
                <el-button v-if="new Date().getFullYear().toString() <= searcheModel.year && is_edit && !hasOrderSensitiveData(list)" type="primary" size="small" @click="setGoal(list)">设置业绩目标</el-button>
                <el-button v-if="new Date().getFullYear().toString() <= searcheModel.year && is_edit && !hasOrderSensitiveData(list)" type="primary" size="small" @click="saveGoal(list, 1)" :loading="saveLoading" :disabled="is_disabled_save">保存</el-button>
            </el-col>
        </el-row>
        <div class="main-bd mg20 pro-visible" v-loading="loading">
            <h3>新增业绩目标</h3>
            <el-table 
            v-if="!loading"
            :data="list" 
            border 
            height="450"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="1"
            >
                <template v-if="searcheModel.count_type == 1">
                    <el-table-column prop="branch_name" label="部门" width="120"></el-table-column>
                </template>
                <template v-else>
                    <el-table-column prop="user_name" label="业务员"></el-table-column>
                    <el-table-column prop="role_name" label="所属职位"></el-table-column>
                    <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                </template>
                <el-table-column prop="sum" label="目标合计"></el-table-column>
                <el-table-column prop="january" sortable label="1月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'january')">{{ scope.row.january }}</span>
                    <el-input v-else v-model="scope.row.january" type="number" :ref="'edit_input_january' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="february" sortable label="2月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'february')">{{ scope.row.february }}</span>
                    <el-input v-else v-model="scope.row.february" type="number" :ref="'edit_input_february' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="march" sortable label="3月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'march')">{{ scope.row.march }}</span>
                    <el-input v-else v-model="scope.row.march" type="number" :ref="'edit_input_march' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="april" sortable label="4月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'april')">{{ scope.row.april }}</span>
                    <el-input v-else v-model="scope.row.april" type="number" :ref="'edit_input_april' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="may" sortable label="5月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'may')">{{ scope.row.may }}</span>
                    <el-input v-else v-model="scope.row.may" type="number" :ref="'edit_input_may' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="june" sortable label="6月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'june')">{{ scope.row.june }}</span>
                    <el-input v-else v-model="scope.row.june" type="number" :ref="'edit_input_june' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="july" sortable label="7月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'july')">{{ scope.row.july }}</span>
                    <el-input v-else v-model="scope.row.july" type="number" :ref="'edit_input_july' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="august" sortable label="8月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'august')">{{ scope.row.august }}</span>
                    <el-input v-else v-model="scope.row.august" type="number" :ref="'edit_input_august' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="september" sortable label="9月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'september')">{{ scope.row.september }}</span>
                    <el-input v-else v-model="scope.row.september" type="number" :ref="'edit_input_september' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="october" sortable label="10月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'october')">{{ scope.row.october }}</span>
                    <el-input v-else v-model="scope.row.october" type="number" :ref="'edit_input_october' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="november" sortable label="11月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'november')">{{ scope.row.november }}</span>
                    <el-input v-else v-model="scope.row.november" type="number" :ref="'edit_input_november' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="december" sortable label="12月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'december')">{{ scope.row.december }}</span>
                    <el-input v-else v-model="scope.row.december" type="number" :ref="'edit_input_december' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-row class="searchSection">
            <el-col :span="6" :offset="18">
                <ImportFile 
                v-if="Acs('/import/' + searcheModel.active_name) && is_edit"
                :templateFileUrl="'/api/export/' + searcheModel.active_name + '-template'" 
                :url="'/api/import/' + searcheModel.active_name"  
                :params="searcheModel2" 
                dialogTitle="部门目标" 
                buttonText="导入目标"
                buttonType="warning"
                @import_success="importSuccess">
                </ImportFile>&nbsp;&nbsp;
                <el-button v-if="new Date().getFullYear().toString() <= searcheModel.year && is_edit" type="primary" size="small" @click="setGoal(order_list)">设置单数目标</el-button>
                <el-button v-if="new Date().getFullYear().toString() <= searcheModel.year && is_edit" type="primary" size="small" @click="saveGoal(order_list, 4)" :loading="saveLoading" :disabled="is_disabled_save">保存</el-button>
            </el-col>
        </el-row>
        <div class="main-bd mg20 pro-visible" v-loading="order_loading">
            <h3>新增单数目标</h3>
            <el-table 
            v-if="!order_loading"
            :data="order_list" 
            border 
            height="450"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="1"
            >
                <template v-if="searcheModel.count_type == 1">
                    <el-table-column prop="branch_name" label="部门" width="120"></el-table-column>
                </template>
                <template v-else>
                    <el-table-column prop="user_name" label="业务员"></el-table-column>
                    <el-table-column prop="role_name" label="所属职位"></el-table-column>
                    <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                </template>
                <el-table-column prop="sum" label="目标合计"></el-table-column>
                <el-table-column prop="january" sortable label="1月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'january')">{{ scope.row.january }}</span>
                    <el-input v-else v-model="scope.row.january" type="number" :ref="'edit_input_january' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="february" sortable label="2月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'february')">{{ scope.row.february }}</span>
                    <el-input v-else v-model="scope.row.february" type="number" :ref="'edit_input_february' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="march" sortable label="3月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'march')">{{ scope.row.march }}</span>
                    <el-input v-else v-model="scope.row.march" type="number" :ref="'edit_input_march' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="april" sortable label="4月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'april')">{{ scope.row.april }}</span>
                    <el-input v-else v-model="scope.row.april" type="number" :ref="'edit_input_april' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="may" sortable label="5月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'may')">{{ scope.row.may }}</span>
                    <el-input v-else v-model="scope.row.may" type="number" :ref="'edit_input_may' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="june" sortable label="6月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'june')">{{ scope.row.june }}</span>
                    <el-input v-else v-model="scope.row.june" type="number" :ref="'edit_input_june' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="july" sortable label="7月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'july')">{{ scope.row.july }}</span>
                    <el-input v-else v-model="scope.row.july" type="number" :ref="'edit_input_july' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="august" sortable label="8月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'august')">{{ scope.row.august }}</span>
                    <el-input v-else v-model="scope.row.august" type="number" :ref="'edit_input_august' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="september" sortable label="9月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'september')">{{ scope.row.september }}</span>
                    <el-input v-else v-model="scope.row.september" type="number" :ref="'edit_input_september' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="october" sortable label="10月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'october')">{{ scope.row.october }}</span>
                    <el-input v-else v-model="scope.row.october" type="number" :ref="'edit_input_october' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="november" sortable label="11月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'november')">{{ scope.row.november }}</span>
                    <el-input v-else v-model="scope.row.november" type="number" :ref="'edit_input_november' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="december" sortable label="12月">
                    <template slot-scope="scope">
                    <span v-if="!scope.row.edit_mode" @dblclick="startEditing(scope.row, 'december')">{{ scope.row.december }}</span>
                    <el-input v-else v-model="scope.row.december" type="number" :ref="'edit_input_december' + scope.row.id"></el-input>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
  </template>
  <style scoped>
  </style>
  <script>
  import SaleanalysisCount from "~/services/saleanalysisCount";
  import CountService from "~/services/UserCount";
  import UserCascader from "~/widgets/UserCascader.vue";
  import UserSelect from "~/widgets/UserSelect.vue";
  import Config from "~/config/params";
  import ExportFile from "~/widgets/ExportFile.vue";
  import ImportFile from "~/widgets/ImportFile.vue";
  import CountConfig from "~/widgets/CountConfig.vue";
  export default {
    components: {
        UserCascader,
        UserSelect,
        Config,
        ExportFile,
        ImportFile,
        CountConfig
    },
  
    props: {
        is_edit: {
            type: Boolean,
            default: false
        },
        activeName: {
            type: String,
            default: ''
        }
    },
  
    data() {
        return {
            loading: false,
            list: [],
            order_loading: false,
            order_list: [],
            searcheModel: {},
            searcheModel2: {},
            is_disabled_save: true,
            saveLoading: false,
        };
    },
  
    mounted() {
        this.resetForm();
    },
  
    created() {
        
    },
  
    methods: {
        //重置按钮
        resetForm() {
            this.searcheModel = {
                branch_id: "",
                user_id: "",
                count_type: '1',
                year: new Date().getFullYear().toString(),
                path: this.$route.path,
                tab: this.activeName,
                active_name: 'branch-goal',
                type: 1
            };
            this.$refs['user'].reset();
            this.$refs['branch'].reset();
            this.list = [];
            this.submitSearch();
        },
    
        // 筛选查询
        submitSearch() {
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
            this.searcheModel2 = _.clone(params);
            this.searcheModel2.type = 4;
            this.getOrderList(this.searcheModel2);
        },
    
        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            SaleanalysisCount.getList(params, this.activeName).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        //获取列表2
        getOrderList(params) {
            // loading 动画
            this.order_loading = true;
            SaleanalysisCount.getList(params, this.activeName).then((res) => {
                if (res.code == 0) {
                    this.order_list = res.data;
                }
                this.order_loading = false;
            }).catch((err) => {
                console.error(err);
                this.order_loading = false;
            });
        },

        //切换业务员子组件
        changeUser(object) {
            this.searcheModel.user_id = object.label;
        },

        //切换部门子组件
        changeBranch(value) {
            if (value.length > 0) {
                // 取得最后一级部门作为所属部门
                this.searcheModel.branch_id = value[value.length - 1];
            } else {
                this.searcheModel.branch_id = "";
            }
        },

        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // 第一列不计算合计，显示自定义的文字内容
                if (index === 0) {
                    sums.push('合计：' + data.length + '条');
                    return;
                }
                // 初始化合计值为0
                let sum = 0;
                // 遍历数据，累加顶级行的值
                data.forEach(item => {
                    // 累加当前项的值，注意转换为数字
                    sum += Number(item[column.property]);
                });
                // 如果所有值都是数字，则显示合计结果，否则显示'-'
                if (!isNaN(sum)) {
                    sums.push(Math.round(sum * 100) / 100); // 保留两位小数
                } else {
                    sums.push('--');
                }
            });
            return sums;
        },

        handleClick(){
            this.searcheModel.active_name = 'branch-goal';
            if(this.searcheModel.count_type == 2){
                this.searcheModel.active_name = 'user-goal';
            }
            this.submitSearch();
        },

        startEditing(row, month) {
            if(row.order_sensitive_masked || new Date().getFullYear() > this.searcheModel.year || !this.is_edit){
                return false;
            }

            // 进入编辑模式
            row.edit_mode = true;
            this.$nextTick(() => {
                this.$refs['edit_input_' + month + row.id].focus();
            });
            this.is_disabled_save = false;
        },

        traverseTree(item) {
            if (item.children && item.children.length > 0){
                item.children.forEach(dataRow => {
                    dataRow.edit_mode = true;
                    dataRow = this.traverseTree(dataRow)
                });
            }
            return item;
        },

        setGoal(list){
            if(this.hasOrderSensitiveData(list) || new Date().getFullYear().toString() > this.searcheModel.year || !this.is_edit){
                return false;
            }
            //开启全局编辑模式
            list.forEach(dataRow => {
                dataRow.edit_mode = true;
                // 检查是否有子节点
                dataRow = this.traverseTree(dataRow);
            });
            this.is_disabled_save = false;
        },

        endEditing(row, month) {
            // 退出编辑模式
            row.editMode = false;
        },

        saveGoal(list, type) {
            if (this.hasOrderSensitiveData(list)) {
                return false;
            }
            let params = _.clone(this.searcheModel);
            params['import_list'] = list;
            params['type'] = type;
            this.saveLoading = true;
            CountService.saveGoal(params).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        message: "保存成功!",
                        type: "success",
                    });
                    this.is_disabled_save = true;
                    this.submitSearch();
                }
                this.saveLoading = false;
            }).catch((err) => {
                this.saveLoading = false;
                this.is_disabled_save = true;
                console.error(err);
            });
        },

        importSuccess(){
            this.submitSearch();
        },
        hasOrderSensitiveData(list) {
            return Array.isArray(list) && list.some(item => {
                return item.order_sensitive_masked || this.hasOrderSensitiveData(item.children);
            });
        },
    },
  };
  </script>



// WEBPACK FOOTER //
// src/views/count/table/goalManagePfm.vue